// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.89.0-beta.6f762f94e',
  revision: '6f762f94e',
  branch: 'develop',
  date: 'Thu, 16 Jul 2026 15:09:34 GMT'
};